import { RouterProvider } from "react-router-dom";
import routes from "./routes/index";
import "react-loading-skeleton/dist/skeleton.css";

const App = () => <RouterProvider router={routes} />;

export default App;
